import {MenuItem as MUIMenuItem} from '@mui/material'

export const MenuItem = MUIMenuItem
